rdefine("app/formular/components/FormularBuilder",['backbone','text!formular/main.html','app/formular/collections/UIElementsCollection','app/formular/components/HeadForm',
    'app/formular/collections/FormCollection','app/formular/components/ContainForms','app/formular/components/HeadPhone'],function(Backbone,template,UIElementCollection,HeadForm,FormCollection,ContainForms,HeadPhone) {
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'formular-builder loading',
        dragelements:null,
        formellements:null,
        bindings:{
            ".drag-form-elements":{
                collection:{
                    col:"dragelements",
                    view:HeadForm
                }
            },
            ".placephoneemulator":{
                collection:{
                    col:"formellements",
                    view:HeadPhone
                }
            },
            "input[name=base_name]":{
                value:{
                    events: 'keyup change',
                    data:'model.name'
                }
            },
            "textarea[name=base_finish]":{
                value:{
                    events: 'keyup change',
                    data:'model.finish_message'
                }
            }
        },
        customview:null,
        ContainForms:null,
        initialize:function(options) {
            this.ebus=_.extend({}, Backbone.Events);
            this.ebus.lang = options.lang;
            this.dragelements=new UIElementCollection();
            this.dragelements.ebus=this.ebus;
            console.log("TEST",this.model.get("elements"));
            this.formellements=new FormCollection(this.model.get("elements",[]));
            this.formellements.ebus=this.ebus;

            this.$el.html(Template7.compile(template)());
            this.$el.removeClass("loading");
            this.ContainForms=new ContainForms({el:this.$el.find('.form-elements')[0],collection:this.formellements});

            this.formellements.on("add remove reset change",_.bind(this.updateFieldsModel,this));
            this.$eld=this.$el.find(".floaterposition");
            this.$elc=this.$eld.parent();
            this.$elh=$("header");
            setInterval(_.bind(this.updatePosition,this),200);
        },
        updateFieldsModel:function() {
            var models=[];
            _.each(this.formellements.models,function(item){
                if(item.get("placeholder",false)) {
                    return;
                }
                models.push(item.attributes);
            });
            this.model.set("elements",models);
            console.log("TEST",models);
            this.model.trigger("change");
        },
        updatePosition:function() {
            var scrollPosition=window.scrollY+this.$elh.outerHeight()+10;
            var maxScroll=this.$elc.outerHeight()-this.$eld.outerHeight();
            var currentScroll=0;
            var offsetY=this.$elc.offset().top;
            currentScroll=scrollPosition-offsetY;
            if(currentScroll<0) {
                currentScroll=0;
            }
            if(currentScroll>maxScroll) {
                currentScroll=maxScroll;
            }
            this.$eld.stop(true,false).animate({"top":currentScroll+"px"},100);

            //move emulator
            //console.log(scrollfalsPosition,offsetY,maxScroll,currentScroll);
        }
    });
});
